import { render, staticRenderFns } from "./PlaylistTeacherItemCard.vue?vue&type=template&id=05666c4c&scoped=true&"
import script from "./PlaylistTeacherItemCard.vue?vue&type=script&lang=ts&"
export * from "./PlaylistTeacherItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./PlaylistTeacherItemCard.vue?vue&type=style&index=0&id=05666c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05666c4c",
  null
  
)

export default component.exports